export const API_ROOT = process.env.REACT_APP_API_ROOT || 'http://localhost:3030';
// export const API_ROOT = process.env.REACT_APP_API_ROOT || 'https://dev-api.finneotech.com';
// export const API_ROOT = process.env.REACT_APP_API_ROOT || 'https://api.finneotech.com';
// export const API_ROOT = process.env.REACT_APP_API_ROOT || 'https://stage-api.finneotech.com';
